import { ReactComponent as FlagIcon } from "./svg/tw-flag.svg";
import "../flag-icon.scss";

export const TWFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
